import 'react-datepicker/dist/react-datepicker.css';

import ja from 'date-fns/locale/ja';
import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'react-bootstrap';
import { ButtonVariant } from 'react-bootstrap/types';
import DatePicker, {
  ReactDatePickerProps,
  registerLocale,
} from 'react-datepicker';

registerLocale('ja', ja);

interface DatePickerCustomInputProps {
  value?: string;
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  variant?: ButtonVariant;
}

const DatePickerCustomInput: React.FunctionComponent<DatePickerCustomInputProps> = ({
  value,
  onClick,
  variant,
}) => {
  return (
    <Button variant={variant} onClick={onClick}>
      {value}
    </Button>
  );
};

DatePickerCustomInput.propTypes = {
  value: PropTypes.string,
  onClick: PropTypes.func,
  variant: PropTypes.string,
};

DatePickerCustomInput.defaultProps = {
  value: undefined,
  onClick: undefined,
  variant: undefined,
};

export interface DateTimePickerProps
  extends Pick<
    ReactDatePickerProps,
    | 'dateFormat'
    | 'timeInputLabel'
    | 'selectsStart'
    | 'selectsEnd'
    | 'minDate'
    | 'maxDate'
    | 'startDate'
    | 'endDate'
    | 'selected'
    | 'onChange'
  > {
  variant?: ButtonVariant;
}

const DateTimePicker: React.FunctionComponent<DateTimePickerProps> = ({
  dateFormat,
  timeInputLabel,
  selectsStart,
  selectsEnd,
  minDate,
  maxDate,
  startDate,
  endDate,
  selected,
  onChange,
  variant,
}) => {
  return (
    <DatePicker
      locale="ja"
      todayButton="今日"
      peekNextMonth
      showYearDropdown
      showMonthDropdown
      dropdownMode="select"
      showTimeInput
      dateFormat={dateFormat}
      timeInputLabel={timeInputLabel}
      selectsStart={selectsStart}
      selectsEnd={selectsEnd}
      minDate={minDate}
      maxDate={maxDate}
      startDate={startDate}
      endDate={endDate}
      selected={selected}
      onChange={onChange}
      customInput={React.createElement(DatePickerCustomInput, { variant })}
    />
  );
};

DateTimePicker.propTypes = {
  dateFormat: PropTypes.string,
  timeInputLabel: PropTypes.string,
  selectsStart: PropTypes.bool,
  selectsEnd: PropTypes.bool,
  minDate: PropTypes.instanceOf(Date),
  maxDate: PropTypes.instanceOf(Date),
  startDate: PropTypes.instanceOf(Date),
  endDate: PropTypes.instanceOf(Date),
  selected: PropTypes.instanceOf(Date),
  onChange: PropTypes.func.isRequired,
  variant: PropTypes.string,
};

DateTimePicker.defaultProps = {
  dateFormat: 'yyyy/MM/dd HH:mm',
  timeInputLabel: '時刻：',
  selectsStart: undefined,
  selectsEnd: undefined,
  minDate: undefined,
  maxDate: undefined,
  startDate: undefined,
  endDate: undefined,
  selected: undefined,
  variant: undefined,
};

export default DateTimePicker;
